import { apiGet } from "./requests";

//getStatistics
export const getStatistics = () => {
  let path = "statistics/";
  return apiGet(path);
};
